//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import generateId from '../../../lib/generateId';
import InfoIcon from '../icons/InfoIcon';

export default {
  name: 'BaseInfoMarker',
  data() {
    // An alternative would be to make all of these props and then have
    // specific components that populate the props. Given how this is used
    // though that would just make those components more complicated. They'd
    // have to have a template section containing this component with all the
    // props bound to data in the script section (at least for long items like
    // content). Seemed simpler this way but maybe not.
    //
    // It's true that we're not changing the functionality in the sub-components
    // so extending it, in an OOP fashion, isn't quite right.
    return {
      iconSpanId: `icon-span-${generateId()}`,
      title: '',
      content: '',
      link: { name: 'Manual' },
      hasManualLink: true,
    };
  },
  components: {
    InfoIcon,
  },
};
